module.exports = __webpack_public_path__ + "img/peersRelationship.a896946d.svg";